import TemplateView from '../../../../TemplateView'
import {dayStatuses} from '../../constants'
import {getInstance as dayTooltip} from '../../../../SimpleSingletonTooltip'
import messageResource from '../../../../messageResource'
import {escapeHtmlSymbols} from '../../../../atUtils'

export default class Day extends TemplateView {
    constructor({
        additionalClass = '',
        date = null,
        nonWorking = false,
        onClick = () => {}
    } = {}) {
        super()

        this.params = {
            additionalClass,
            date,
            nonWorking,
        }

        this.callbacks = {
            onClick
        }

        this.state = {
            current: false,
            status: dayStatuses.STANDARD_DAY,
            title: '',
        }

        this.onStatePropertyChanged('current', () => this.$el.toggleClass('current', this.state.current))

        this.onStatePropertyChanged('status', () => {
            this.$el.toggleClass('nonWorking', this.params.nonWorking && this.state.status !== dayStatuses.NON_STANDARD_WORKING_DAY)
            this.$el.toggleClass('corporateHoliday', this.state.status === dayStatuses.CORPORATE_HOLIDAY)
        })
    }

    templateHtml() {
        return "<div class='components_day <%-additionalClass%>'><%=dayNumber%></div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            dayNumber: this.params.date.getDate(),
        }
    }

    afterRender() {
        this.$el.toggleClass('nonWorking', this.params.nonWorking)
        this.$el.click(() => {
            this.callbacks.onClick(this.$el, this.params.date, this.params.nonWorking, this.state.status, this.state.title)
        })

        dayTooltip().subscribeToMouseEvents(this.$el, () => {
            dayTooltip().setState({
                html: this._getDayTooltipHtml(),
                extraClass: "calendarDayTooltip"
            })
        })
    }

    _getDayTooltipHtml() {
        let tooltipText = messageResource.getMessage('work_schedule.working_day_txt')
        if (this.state.status === dayStatuses.CORPORATE_HOLIDAY)
            tooltipText = escapeHtmlSymbols(this.state.title)
        else if (this.params.nonWorking && this.state.status !== dayStatuses.NON_STANDARD_WORKING_DAY)
            tooltipText = messageResource.getMessage('work_schedule.nonworking_day_txt')

        let tooltipNoteKey = 'work_schedule.click_to_edit'
        if (!this.params.nonWorking && this.state.status === dayStatuses.STANDARD_DAY)
            tooltipNoteKey = 'work_schedule.click_to_mark_as_holiday'

        return '<div class="dayStatus">' + tooltipText + '</div>' +
               '<div class="note">' + messageResource.getMessage(tooltipNoteKey) + '</div>'
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/Day.js